import URL from '@/tools/url';
import jquery from 'jquery';
import _toInteger from 'lodash/toInteger';
import _forIn from 'lodash/forIn';
import _last from 'lodash/last';
import _split from 'lodash/split';

/**
 * @memberof module:ajaxAPI/checkout
 * @alias order
 *
 * @description
 * Оформление заказа с указанием способа оплаты и доставки. Важно - все поля обязательны для заполнения.
 *
 * @param {Object} client - объект с полями {email: почта, name: имя, phone: телефон}
 * @param {string} client.email - почта
 * @param {string} client.name - ФИО
 * @param {string} client.phone - телефон
 * @param {Object} order - объект с обязательными полями
 * @param {number} order.delivery - id способа доставки
 * @param {number} order.payment - id способа оплаты
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.checkout.order(client, order)
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(client, order) {
  var result = jquery.Deferred();
  var _lang = URL.getKeyValue('lang') || '';
  var checkout = {
    lang: _lang,
    pid: 1,
    'order[delivery_variant_id]': _toInteger(order.delivery),
    'order[payment_gateway_id]': _toInteger(order.payment)
  };
  var iframe;

  _forIn(client, function(value, field) {
    checkout['client[' + field + ']'] = value;
  });

  _forIn(order.shipping_address, function(value, field) {
    checkout['shipping_address[' + field + ']'] = value;
  });

  if (order.comment) {
    checkout['order[comment]'] = order.comment;
  }

  jquery.post('/fast_checkout.json', checkout)
    .done(function(response) {
      const _order_hash = _last(_split(response.location, '/', 3));

      if (response.status == 'ok') {
        iframe = jquery('<iframe src="/orders/successful?id=' + _order_hash + '" width="0" height="0"></iframe>');

        iframe
          .append('body')
          .on('load', function() {
            return jquery(this).remove();
          });

        result.resolve(response);
      } else {
        result.reject(response);
      }
    })
    .fail(function(response) {
      result.reject(response);
    });

  return result.promise();
}
